import React, { useRef, useState, useMemo } from 'react';
import { AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';
import colors from '@utils/colors';
import { Plus, Minus } from '@components/Icon';

import PersonBubbleItem from './personBubbleItem';
import PersonModal from './personModal';
import SimpleCardBubbleItem from './simpleCardBubbleItem';

import * as styled from './styles';

function PersonBubbleBlock({ bubblesPerRow, items, defaultOpen = false, showItemsInsideAccordion = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [activePerson, setActivePerson] = useState(null);
  const ref = useRef(null);

  const handleClick = (person) => setActivePerson(person);
  const closeModal = () => setActivePerson(null);
  const toggleAccordion = () => setIsOpen(prev => !prev);
  const getIconColor = (expanded) => colors[`B${expanded ? '500' : '170'}`];

  const renderedItems = useMemo(() =>
    items.map(item =>
      item._type === 'simpleBubbleCardItem'
        ? <SimpleCardBubbleItem {...item} key={item._key} />
        : <PersonBubbleItem {...item} key={item._key} onClick={() => handleClick(item)} />,
    ), [items],
  );

  const ItemsWrapper = (
    <>
      <styled.BubbleItems ref={ref} bubblesPerRow={bubblesPerRow}>
        {renderedItems}
      </styled.BubbleItems>
      <AnimatePresence>
        {activePerson && <PersonModal person={activePerson} onClose={closeModal} />}
      </AnimatePresence>
    </>
  );

  const AccordionHeading = (
    <styled.AccordionHeading
      levels={[200, 200]}
      onClick={toggleAccordion}
      className={isOpen ? 'active' : ''}
    >
      {items[0]?.department}
      <styled.IconContainer className={isOpen ? 'active' : ''}>
        <styled.Icon>
          {isOpen ? (
            <Minus size={28} color={getIconColor(true)} />
          ) : (
            <Plus
              size={28}
              color={getIconColor(false)}
              style={{ border: `2px solid ${getIconColor(false)}`, borderRadius: '3px' }}
            />
          )}
        </styled.Icon>
      </styled.IconContainer>
    </styled.AccordionHeading>
  );

  return showItemsInsideAccordion ? (
    <styled.PersonBubbleBlockAccordion>
      {AccordionHeading}
      <styled.AccordionBody className={isOpen ? 'open' : 'closed'}>
        {ItemsWrapper}
      </styled.AccordionBody>
    </styled.PersonBubbleBlockAccordion>
  ) : (
    <styled.Wrapper>
      {ItemsWrapper}
    </styled.Wrapper>
  );
}

PersonBubbleBlock.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  bubblesPerRow: PropTypes.number,
  defaultOpen: PropTypes.bool,
  showItemsInsideAccordion: PropTypes.bool,
};

export default PersonBubbleBlock;
